import React from "react";
import isHospital from "./component/Hospital";
import MyForm from "./Token"
import IsCard from "./Card";
import About from "./component/about";
import Detail from "./component/Detail";
import { Routes,Route } from "react-router-dom";

export default function App() {
  return (
      <Routes>
          <Route exact path="/" Component={IsCard}></Route>
          <Route exact path="/about" Component={About}></Route>
          <Route exact path="/hospital" Component={isHospital}></Route> 
          <Route exact path="/detail/:detailId" Component={Detail}></Route> 
      </Routes>
  );
}